import { Link, Text } from "@chakra-ui/react";
import React from "react";
import type { TermsAndConditions } from "@shared/graphql.types";

export const InterpolateWithLinks: React.FC<{
  data: TermsAndConditions;
}> = ({ data }) => {
  const { template, links } = data;

  if (!template) return null;

  // 1. Split template by `<[number]>` match
  const parts = template.split(/(<\d+>)/);

  return (
    <>
      {parts.map((part) => {
        // 2. Extract number from match created in 1.
        const match = part.match(/<(\d+)>/);
        if (match) {
          const linkIndex = parseInt(match[1], 10);
          const link = links && links[linkIndex];

          if (!link?.href || !link.text) return null;

          return (
            <Link
              key={link.href}
              href={link.href}
              target="_blank"
              textDecoration="underline"
            >
              {link.text}
            </Link>
          );
        }
        return (
          <Text
            as="span"
            key={part}
            // N.B: We need to set the copy as HTML to allow for passing elements like <b>
            dangerouslySetInnerHTML={{ __html: part }}
          />
        );
      })}
    </>
  );
};
